import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { pagePath } from '@/utils/router/pagePath';
import { OFFER_STATUS_SELECTION } from '../../../../define/consts/rfp';
import { propArrayShape, propShape, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ClientRfpHoc from '../Hoc/ClientRfpHoc';
import RfpOneSkeleton from './RfpOneSkeleton';
const RfpOneRedirect = (props) => {
    const { offers, rfp } = props;
    const { is_call_end: isCallEnd, is_interview_view: isInterviewView } = rfp;
    const interviews = useMemo(() => offers.filter((v) => v.offer.interview_status), [offers]);
    const isAllInterviewAnswered = interviews.length > 0 &&
        offers.every((v) => v.offer.status !== OFFER_STATUS_SELECTION.value);
    if (isCallEnd) {
        if (isAllInterviewAnswered) {
            // ③3つ目のフェーズに移行するタイミングは、全員に面談依頼or面談しないを押した時
            // これは面談依頼の期限に関係なく、このタイミング。なので、全員を押し終わったら、そのタイミングで3つ目にいってOK
            // その案件をそれ以降見ると、3フェーズ目が最初に見える形にする
            return _jsx(CustomRedirect, { to: pagePath.project.client.order(rfp.id) });
        }
        // ②募集期限を過ぎた段階で、案件の詳細画面を見ると、2つ目のフェーズが最初に表示される（1つ目のフェーズ画面ではない）
        // なお、アニメーションについては、「提案を見る」を一回押せば、その人には以降表示されない。
        // （1案件につき1回のみ。Aさんが見たら、Aさんには以降表示されない。Aさんが見た後でも、Bさんにとって初めてだったら、Bさんに表示し、ボタンを押したら以降表示されないという感じ）
        if (offers.length > 0 && isInterviewView) {
            return (_jsx(CustomRedirect, { to: pagePath.project.client.interviewList(rfp.id) }));
        }
        return _jsx(CustomRedirect, { to: pagePath.project.client.interview(rfp.id) });
    }
    // ①案件の募集期限が終わるまでは、1つ目のフェーズの画面
    // ※提案があった場合、2つ目のフェーズの画面を開くことはできる
    return _jsx(CustomRedirect, { to: pagePath.project.client.offer(rfp.id) });
};
RfpOneRedirect.propTypes = {
    offers: propArrayShape().isRequired,
    rfp: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isCanUseProffit: true,
    isPreClient: false,
    isPreview: true,
}), ClientRfpHoc({}, RfpOneSkeleton));
export default enhance(RfpOneRedirect);
